"use client"

import MarkIcon from "@/components/icons/MarkIcon"
import SelectPlacement from "./SelectPlacement"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import { useTranslation } from "react-i18next"

let timeoutSearch: any = null

const SelectDestination = () => {
  const dispatch = useAppDispatch()
  const tourCategory = useAppSelector(state => state.tour.formSearch.tourCategory)
  const destinationSearchError = useAppSelector(
    state => state.tour.formSearch.destinationSearchError
  )
  const { t } = useTranslation()

  return (
    <SelectPlacement
      placeholder={t("tour.to_placeholder")}
      label={t("tour.to")}
      icon={<MarkIcon />}
      hasError={destinationSearchError}
      value={tourCategory}
      onSearch={(val) => {
        if (timeoutSearch) {
          clearTimeout(timeoutSearch)
        } 
        timeoutSearch = setTimeout(() => {
          dispatch(tourActions.searchDestinations(val))
        }, 500)
      }}
      onChange={(valueObject) => {
        dispatch(tourActions.selectTourCategory(valueObject))
      }}
    />
  )
}

export default SelectDestination